module.exports = __webpack_public_path__ + "static/media/crm.011278d7.svg";